// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguageSwitcher_wrapper__5d6Pb","buttonVariant":"LanguageSwitcher_buttonVariant__yAgvR","dropdownVariant":"LanguageSwitcher_dropdownVariant__HOxUI"};